/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Not found
 * @export
 * @interface GetUniverseAsteroidBeltsAsteroidBeltIdNotFound
 */
export interface GetUniverseAsteroidBeltsAsteroidBeltIdNotFound {
    /**
     * Not found message
     * @type {string}
     * @memberof GetUniverseAsteroidBeltsAsteroidBeltIdNotFound
     */
    error?: string;
}

/**
 * Check if a given object implements the GetUniverseAsteroidBeltsAsteroidBeltIdNotFound interface.
 */
export function instanceOfGetUniverseAsteroidBeltsAsteroidBeltIdNotFound(value: object): value is GetUniverseAsteroidBeltsAsteroidBeltIdNotFound {
    return true;
}

export function GetUniverseAsteroidBeltsAsteroidBeltIdNotFoundFromJSON(json: any): GetUniverseAsteroidBeltsAsteroidBeltIdNotFound {
    return GetUniverseAsteroidBeltsAsteroidBeltIdNotFoundFromJSONTyped(json, false);
}

export function GetUniverseAsteroidBeltsAsteroidBeltIdNotFoundFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetUniverseAsteroidBeltsAsteroidBeltIdNotFound {
    if (json == null) {
        return json;
    }
    return {
        
        'error': json['error'] == null ? undefined : json['error'],
    };
}

export function GetUniverseAsteroidBeltsAsteroidBeltIdNotFoundToJSON(json: any): GetUniverseAsteroidBeltsAsteroidBeltIdNotFound {
    return GetUniverseAsteroidBeltsAsteroidBeltIdNotFoundToJSONTyped(json, false);
}

export function GetUniverseAsteroidBeltsAsteroidBeltIdNotFoundToJSONTyped(value?: GetUniverseAsteroidBeltsAsteroidBeltIdNotFound | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'error': value['error'],
    };
}

